type DetailViewModel = 'Driver' | 'User' | 'Driver Profile' | 'Site';

export const DetailViewModels = {
  driver: 'Driver' as DetailViewModel,
  user: 'User' as DetailViewModel,
  driverProfile: 'Driver Profile' as DetailViewModel,
  site: 'Site' as DetailViewModel,
};
